"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
var _Khal = _interopRequireDefault(require("../../components/Business/Khal"));
var _KPricing = _interopRequireDefault(require("../../components/Business/KPricing"));
var _KPartner = _interopRequireDefault(require("../../components/Business/KPartner"));
var _KSme = _interopRequireDefault(require("../Business/KSme"));
var _KAudioVB = _interopRequireDefault(require("../Business/KAudioVB"));
var _KActivity = _interopRequireDefault(require("../Business/KActivity"));
var _KActivityBanner = _interopRequireDefault(require("../Business/KActivityBanner"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/prefer-optional-chain */

var NewBanner = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    _a = props.buttonList,
    buttonList = _a === void 0 ? [] : _a,
    title = props.title,
    content = props.content,
    backgroundUrl = props.backgroundUrl,
    backgroundVideoUrl = props.backgroundVideoUrl,
    backgroundUrlLogo = props.backgroundUrlLogo,
    _b = props.lightTheme,
    lightTheme = _b === void 0 ? true : _b,
    _c = props.liveType,
    liveType = _c === void 0 ? '' : _c,
    _d = props.tabList,
    tabList = _d === void 0 ? [] : _d,
    onCallback = props.onCallback,
    styleType = props.styleType,
    restProps = __rest(props, ["className", "buttonList", "title", "content", "backgroundUrl", "backgroundVideoUrl", "backgroundUrlLogo", "lightTheme", "liveType", "tabList", "onCallback", "styleType"]);
  var formatBackgroundUrl = (0, _utils.fomateFileData)(backgroundUrl).url;
  var _e = (0, _utils.fomateFileData)(backgroundVideoUrl),
    formatBackgroundVideoUrl = _e.url,
    _f = _e.alt,
    alt = _f === void 0 ? '' : _f;
  var _g = (0, _utils.fomateFileData)(backgroundUrlLogo),
    formatBackgroundUrlLogo = _g.url,
    _h = _g.alt,
    logoAlt = _h === void 0 ? '' : _h;
  var _j = (0, _react.useState)(false),
    status = _j[0],
    setStatus = _j[1];
  var kindTypeCyan = function kindTypeCyan(type) {
    return ['cyan'].includes(type || 'default');
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-new-banner', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-new-banner-container'
  }, formatBackgroundVideoUrl ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-banner-container-video-bg', {
      'light-theme': lightTheme
    })
  }, /*#__PURE__*/_react["default"].createElement("video", {
    loop: true,
    muted: true,
    autoPlay: true,
    src: formatBackgroundVideoUrl,
    className: 'video-control',
    title: alt
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-banner-container-img-bg', {
      'flex-new-banner-container-img-show': !(formatBackgroundVideoUrl && formatBackgroundVideoUrl !== ''),
      'light-house-style': styleType === 'lightHouse'
    }),
    style: formatBackgroundUrl ? {
      background: "url(" + formatBackgroundUrl + ") center no-repeat ",
      backgroundSize: 'cover'
    } : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-new-banner-container-external'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-new-banner-container-children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-banner-container-left-container', {
      'audiovb-container': ['audiovb'].includes(liveType)
    })
  }, tabList && tabList.length > 0 ? (
  /*#__PURE__*/
  // 移动端ddos
  _react["default"].createElement("div", {
    className: 'new-banner-tab-mobile'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tab-text', {
      'light-theme': lightTheme
    }),
    onClick: function onClick() {
      setStatus(true);
    }
  }, tabList && tabList.filter(function (item) {
    return item.chosed;
  }).map(function (item, index) {
    var _a = item || {},
      text = _a.text,
      chosed = _a.chosed;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, chosed ? text : '');
  }), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow_down-24px"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Path",
    d: "M7 9L12 15L17 9L7 9Z",
    fill: "white",
    style: lightTheme ? {
      fill: '#000000'
    } : {}
  })))), status && ( /*#__PURE__*/_react["default"].createElement("section", {
    className: 'new-banner-tab-mobile-root'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'new-banner-tab-mobile-mask'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'new-banner-tab-mobile-wrap',
    onClick: function onClick() {
      if (status) {
        setStatus(false);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabList && tabList.map(function (item, index) {
    var _a = item || {},
      text = _a.text,
      href = _a.href,
      chosed = _a.chosed;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: (0, _classnames["default"])({
        on: chosed
      })
    }, text));
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: 'close',
    onClick: function onClick() {
      if (status) {
        setStatus(false);
      }
    }
  }, "\u53D6\u6D88"))))))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-banner-container-left', {
      'container-left-max-width': tabList.length > 0
    })
  }, tabList && tabList.length > 0 ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "new-banner-tab mian"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabList && tabList.map(function (item, index) {
    var _a = item || {},
      text = _a.text,
      href = _a.href,
      chosed = _a.chosed;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: (0, _classnames["default"])({
        on: chosed
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: (0, _classnames["default"])('', {
        'light-theme': lightTheme
      })
    }, text));
  })))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('banner-title', {
      'light-theme': lightTheme,
      hasTabList: tabList.length > 0,
      'title-audiovb': ['audiovb'].includes(liveType),
      'light-house-style': styleType === 'lightHouse'
    }),
    dangerouslySetInnerHTML: {
      __html: title || ''
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('banner-content', {
      'light-theme': lightTheme,
      hasTabList: tabList.length > 0,
      'desc-audiovb': ['audiovb'].includes(liveType),
      'light-house-style': styleType === 'lightHouse',
      'activity-theme': liveType === 'activity'
    }),
    dangerouslySetInnerHTML: {
      __html: content || ''
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-banner-container-left-div', {
      hasTabList: tabList.length > 0
    })
  }, buttonList.map(function (item, index) {
    var _a = item || {},
      iconUrl = _a.iconUrl,
      extendProps = _a.extendProps,
      type = _a.type;
    var _b = (0, _utils.fomateFileData)(iconUrl),
      formatIconUrl = _b.url,
      _c = _b.alt,
      iconAlt = _c === void 0 ? '' : _c;
    return item.filedVideoList ? ( /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: (0, _classnames["default"])('not-a-style', {
        'light-theme': lightTheme,
        'audiovb-theme': ['audiovb'].includes(liveType),
        'banner-theme-cyan': kindTypeCyan(type),
        'bg-yellow': styleType === 'lightHouse'
      }),
      key: index
    }, extendProps || {}, {
      onClick: function onClick() {
        (0, _utils.reinitIframe)({
          filedVideoBg: item.filedVideoBg,
          filedVideoList: item.filedVideoList,
          postMessageUrl: item.postMessageUrl
        });
      }
    }), formatIconUrl && ( /*#__PURE__*/_react["default"].createElement("img", {
      src: formatIconUrl,
      width: 24,
      height: 24,
      alt: iconAlt
    })), item.label)) : !onCallback ? ( /*#__PURE__*/_react["default"].createElement("a", __assign({}, extendProps || {}, {
      className: (0, _classnames["default"])('not-a-style', {
        'light-theme': lightTheme,
        'audiovb-theme': ['audiovb'].includes(liveType),
        'banner-theme-cyan': kindTypeCyan(type),
        'bg-yellow': styleType === 'lightHouse'
      }),
      key: index,
      href: item.href
    }), formatIconUrl && ( /*#__PURE__*/_react["default"].createElement("img", {
      src: formatIconUrl,
      width: 24,
      height: 24,
      alt: iconAlt
    })), item.label)) : ( /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: (0, _classnames["default"])('not-a-style', {
        'light-theme': lightTheme,
        'audiovb-theme': ['audiovb'].includes(liveType),
        'banner-theme-cyan': kindTypeCyan(type)
      }),
      key: index,
      href: "javascript:void(0);",
      onClick: function onClick() {
        onCallback && onCallback(item);
      }
    }, extendProps || {}), formatIconUrl && ( /*#__PURE__*/_react["default"].createElement("img", {
      src: formatIconUrl,
      width: 24,
      height: 24,
      alt: iconAlt
    })), item.label));
  }))), liveType ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-new-bg-c-hero-icon-mod', {
      'flex-new-bg-c-hero-icon-mod-show': liveType,
      'flex-new-bg-c-hero-icon-mod-show--width': ['sme'].includes(liveType),
      'audiovb-show': ['audiovb'].includes(liveType),
      hasTabList: tabList.length > 0
    })
  }, liveType === 'customers' && /*#__PURE__*/_react["default"].createElement(_Khal["default"], null), liveType === 'pricing' && /*#__PURE__*/_react["default"].createElement(_KPricing["default"], null), liveType === 'partner' && /*#__PURE__*/_react["default"].createElement(_KPartner["default"], null), liveType === 'sme' && /*#__PURE__*/_react["default"].createElement(_KSme["default"], null), liveType === 'audiovb' && /*#__PURE__*/_react["default"].createElement(_KAudioVB["default"], null), liveType === 'activity' && /*#__PURE__*/_react["default"].createElement(_KActivity["default"], null), liveType === 'activityBanner' && /*#__PURE__*/_react["default"].createElement(_KActivityBanner["default"], null))) : formatBackgroundUrlLogo ? ( /*#__PURE__*/_react["default"].createElement("img", {
    className: (0, _classnames["default"])('flex-new-bg-c-hero-icon-mod', {
      'flex-new-bg-c-hero-icon-mod-show': !(formatBackgroundVideoUrl && formatBackgroundVideoUrl !== ''),
      hasTabList: tabList.length > 0
    }),
    src: formatBackgroundUrlLogo,
    alt: logoAlt
  })) : null)))));
});
NewBanner.displayName = 'TCINewBanner';
var _default = exports["default"] = NewBanner;